module.exports = __webpack_public_path__ + "static/img/h5.4114bcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5.png
// module id = 6OY6
// module chunks = 1